<template>
    <div class="container">
        <h1>Acceptance</h1>
        <el-alert
            :closable="false"
            title="Not finding the facility you are looking for?"
            description="The table below only lists national facilities that are in the process of being evaluated for their acceptance. If the facility you are looking for does not appear in the table the facility might not have submitted the application or the evaluation process might have ended, in which case you will find the facility in the Quality Assurance page."
            type="primary"
            show-icon
        >
        </el-alert>
        <div class="row justify-content-center">
            <div class="col">
                <FacilitiesTable show-profile show-acceptance show-documents show-reviewers waiting-for-review />
            </div>
        </div>
    </div>
</template>

<script>
import FacilitiesTable from '@/components/facilities/FacilitiesTable.vue'

export default {
    name: 'CARSFacilitiesIAReview',
    components: {
        FacilitiesTable
    },
    data: () => {
        return {
        }
    },
    head: {
        title: 'Evaluate National Facilities'
    },
    methods: {
    },
    async mounted() {
    }
}
</script>